@import '../../../theme.scss';

verdocs-dropdown {
  height: 26px;
  display: block;
  position: relative;
  font-family: $primary-font;

  .arrow {
    height: 26px;
    padding: 0 4px;
    background: #fff;
    cursor: pointer;
    border-radius: 4px;
    align-items: center;
    display: inline-flex;
    border: 1px solid $light-border-color;
    justify-content: center;
  }

  .arrow svg {
    fill: $primary-color;
    transition: 0.3s;
  }

  &.open {
    .arrow {
      background: $secondary-color;
      border: 1px solid $border-color;
    }

    .arrow svg {
      transform: scaleY(-1);
      fill: #fff;
    }
  }
}

#verdocs-dropdown-menu-items {
  width: 200px;
  z-index: 10000;
  position: absolute;
  border-radius: 5px;
  background: $medium-bg;
  border: 1px solid $item-border-color;
}

.verdocs-dropdown-menu-separator {
  height: 1px;
  margin-top: 5px;
  padding-top: 5px;
  border-top: 1px solid #ffffff5f;
}

.verdocs-dropdown-menu-option {
  width: 100%;
  color: #fff;
  border: none;
  display: block;
  text-align: left;
  background: none;
  text-wrap: nowrap;
  padding: 10px 20px;
}

.verdocs-dropdown-menu-option:hover {
  cursor: pointer;
  background: $primary-color;
}

.verdocs-dropdown-menu-option[disabled] {
  color: $light-disabled-color;
}

.verdocs-dropdown-menu-option[disabled]:hover {
  cursor: inherit;
  background: transparent;
  color: $light-disabled-color;
}
